import { FC, useEffect } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useThemeContext } from '../global/ThemeContext';
import useTranslations from '../global/translation/hooks/translation';

// Added dark mode toggle functionality
const DarkModeToggle: FC = () => {
  const { darkMode, toggleDarkMode } = useThemeContext();
  const { currentLanguage } = useTranslations();

  useEffect(() => {
    document.body.style.transition = 'background-color 0.5s ease';
    document.body.style.backgroundColor = darkMode ? '#07142B' : '#F3F6FB';
  }, [darkMode]);

  return (
    <Tooltip title={darkMode ? (currentLanguage === 'en' ? 'Light mode' : 'Tryb jasny') : currentLanguage === 'en' ? 'Dark mode' : 'Tryb ciemny'}>
      <IconButton
        onClick={toggleDarkMode}
        sx={{
          color: darkMode ? '#F6F8FC' : '#0B1834',
          transition: 'transform 0.3s ease-in-out',
          '&:hover': {
            transform: 'rotate(30deg)',
          },
        }}
      >
        {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default DarkModeToggle;
